



























































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { opcaoHabilitadoShared, campoHabilitadoShared, validateCPFCNPJ } from '@/utils/common'
import { HonorarioMedicoEnum } from '@/types/_'

@Component
export default class BackofficeHonorarioMedico extends Vue {
  $refs!: { honorarioMedico: any }

  honorarioMedicoRules: any = {
    valid: true,
    codigoPrestador: [(v: any) => !!v || 'Campo obrigatório.'],
    honorarioMedicoDocumento: [(v: any) => this.validateCPFCNPJUtil(v)],
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  campoHabilitado(prop: string) {
    return campoHabilitadoShared(this.getBackofficeGlobalStore.template, prop)
  }

  opcaoHabilitado(prop1: string, prop2: string) {
    return opcaoHabilitadoShared(this.getBackofficeGlobalStore.template, prop1, prop2)
  }

  validateCPFCNPJUtil(value) {
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    const cleanedValue = value.replaceAll(/[\.\/-]/g, '')
    if (cleanedValue.length < 11) return 'CPF inválido'
    if (cleanedValue.length === 11) return validateCPFCNPJ(cleanedValue) || 'CPF inválido.'
    if (cleanedValue.length > 11 && cleanedValue.length < 14) return 'CNPJ inválido.'
    if (cleanedValue.length === 14) return validateCPFCNPJ(cleanedValue) || 'CNPJ inválido.'
    return false
  }

  honorarioMedicoChange() {
    if (this.getBackofficeGlobalStore.solicitacaoAlterada.honorarioMedico !== HonorarioMedicoEnum.Consultorio) {
      this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'codigoPrestador', value: '' })
      this.honorarioMedicoRules.codigoPrestador.splice(0, this.honorarioMedicoRules.codigoPrestador.length)
    } else {
      this.honorarioMedicoRules.codigoPrestador.push((v: any) => !!v || 'Campo obrigatório.')
    }

    if (this.opcaoHabilitado('honorarioMedico', 'honorarioMedicoDocumento')) {
      if (this.getBackofficeGlobalStore.solicitacaoAlterada.honorarioMedico !== HonorarioMedicoEnum.Particular) {
        this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'honorarioMedicoDocumento', value: null })
        this.honorarioMedicoRules.honorarioMedicoDocumento.splice(0, this.honorarioMedicoRules.honorarioMedicoDocumento.length)
      } else {
        this.honorarioMedicoRules.honorarioMedicoDocumento.push((v: any) => this.validateCPFCNPJUtil(v))
      }
    }
    this.$forceUpdate()
  }
}
